import { ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Component, AfterViewInit } from '@angular/core';

import { MoteEventType, MoteEvent, Coords, Mote, AudioItemEvent, AudioItemId, AudioItem, AudioItemListenerId } from '../../models';

// From local motes SDK
import { MapService } from '../../providers';
import { AutoSubOnDestroy, AutoSub } from '../../providers/auto-sub';
import { MoteEventService } from '../../providers/mote-event.service';

@AutoSubOnDestroy()
@Component({
    selector: 'augmented-map-marker-group',
    encapsulation: ViewEncapsulation.None, // Set to None as we cant contain this in component selector because only part of the dom is inserted as mapbox marker
    changeDetection: ChangeDetectionStrategy.Default,
    template: `
        <!-- Marker for Ambisonic item -->
        <augmented-map-marker *ngIf="showMarkers"></augmented-map-marker>
    	<augmented-map-marker *ngFor="let item of audioItemList" [audioItem]="item" [mote]="mote"></augmented-map-marker>
    `
})
/**
 * Spawn a instances of AugmentedMapMarker's for each item in augmented audio item list
 */
export class AugmentedMapMarkerGroup implements AfterViewInit {
    public showMarkers = false;
    public audioItemList: AudioItem[] = [];
    public mote: Mote = null;

    constructor(private mapService: MapService, private moteEventService: MoteEventService) {
    }

    ngAfterViewInit() {
        // Wait for map to init, then listen for mote events
        this.mapService.awaitInit().then(map => {
            this.initListners(this.mapService);
        });
    }

    // Make initListners public for debug purposes
    public initListners(mapService: MapService) {
        AutoSub(this).reg['eventSub'] = this.moteEventService.watchMoteEvents().subscribe((ev: MoteEvent) => {
            switch(ev.type) {
                case MoteEventType.HIDE_3D_MOTE_ON_MAP:
                    this.showMarkers = false;
                    this.audioItemList = [];
                    break;
                case MoteEventType.SHOW_3D_MOTE_ON_MAP:
                    this.mote = ev.mote;
                    this.showMarkers = true;
                    // Get list of audio items (Ambisonic item not included - for now)
                    this.audioItemList = ev.mote.image.augmentedAudioList;
                    console.log("Got audio item list ", this.audioItemList.length);
                    break;
            }
        });
    }
}
